


































































































































































































import "./member-setup.less";
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import UserAvatar from "../../components/common/user-avatar.vue";
import Modal from "../../components/common/confirm.js";

export default Vue.extend({
  name: "member-setup",
  components: { UserAvatar },
  props: {
    member: Object,
    showSetup: Boolean,
  },
  data() {
    return {
      listMode: false,
      currentPage: "members",
      currentMember: null,
      changingRoleByUser: true,
      currentMemberOriginalRole: null,
      rules: {
        role: [
          {
            required: true,
            message: "Please choose permission",
            trigger: "blur",
          },
        ],
      },
      sending: false,
      inviteModel: {
        memberId: null,
        role: null,
      },
      inviteFormRules: {
        memberId: [
          {
            type: "number",
            required: true,
            message: "Please select a user",
            trigger: "blur",
          },
        ],
        role: [
          {
            type: "number",
            required: true,
            message: "Please select a role",
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {
    showModal(newVal) {
      if (newVal === true) {
        this.listMode = this.member ? false : true;
        this.currentPage = "members";
        if (this.member) {
          this.assignCurrentMember(this.member);
          this.currentPage = "member";
        }
      }
    },
  },
  computed: {
    ...mapState("billing", ["billingAccount"]),
    ...mapState("goal", ["currentGoal"]),
    ...mapGetters("goal", ["canEditCurrentGoal", "currentGoalInviteRoles", "getRoleDetails", "roleTitle", "memberRoleTitle", "permissionOptions"]),
    showModal: {
      get: function () {
        return (this as any).showSetup;
      },
      set: function (newValue) {
        (this as any).$emit("cancel");
      },
    },
    allMembers() {
      let context = this as any;
      let goal = context.$store.state.goal.currentGoal;
      let members = goal && goal.members ? goal.members : [];
      if (members === null) {
        members = [];
      }

      return members.map((member, index) => {
        return {
          adminFlag: "",
          memberId: member.memberId,
          memberName: member.memberName,
          memberEmailAddress: member.memberEmailAddress,
          memberPhoneNumber: member.memberPhoneNumber,
          memberAvatarImageUrl: member.memberAvatarImageUrl,
          role: member.role,
        };
      });
    },
    memberRoleMembers() {
      let allMembers = this.allMembers;

      if (allMembers && allMembers.length > 0) {
        return allMembers.filter((member) => member.role == 3);
      } else {
        return [];
      }
    },
    authorOnlyMembers() {
      let allMembers = this.allMembers;

      if (allMembers && allMembers.length > 0) {
        return allMembers.filter((member) => member.role == 5);
      } else {
        return [];
      }
    },
    authorAndContributors() {
      let allMembers = this.allMembers;

      if (allMembers && allMembers.length > 0) {
        return allMembers.filter((member) => member.role == 6);
      } else {
        return [];
      }
    },
    guestMembers() {
      let allMembers = this.allMembers;
      if (allMembers && allMembers.length > 0) {
        return allMembers.filter((member) => member.role == 4);
      } else {
        return [];
      }
    },
    pageTitle() {
      if (this.currentPage == "members") {
        return "Target Role Assignments";
      } else if (this.currentPage == "member") {
        return "User";
      } else if (this.currentPage == "invite") {
        return "Invite";
      } else if (this.currentPage == "remove") {
        return "Remove User?";
      } else {
        return "";
      }
    },
    showPageTitle() {
      return !(!this.listMode && this.currentPage == "member");
    },
    showBackButton() {
      return !((!this.listMode && this.currentPage == "member") || (this.listMode && this.currentPage == "members"));
    },
    accountUsers() {
      let context = this as any;
      let members = context.billingAccount && context.billingAccount.members ? context.billingAccount.members.filter((m) => m.licenseAssigned === true) : [];
      if (context.currentGoal && context.currentGoal.members) {
        members = members.filter((m) => context.currentGoal.members.filter((member) => member.memberId === m.memberId).length === 0);
      }

      return members;
    },
  },
  mounted() {
    this.loadAccountInfo();
  },
  methods: {
    loadAccountInfo() {
      this.$store
        .dispatch("billing/getBillingAccountInfo")
        .then((response) => {})
        .finally(() => {});
    },
    handleSendInvite() {
      let context = this;
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;
      context.sending = true;

      let goalId = context.$store.state.goal.currentGoal.id;

      let form = context.$refs.InviteForm as any;
      form.validate((valid: boolean) => {
        if (valid) {
          context.$store
            .dispatch("goal/inviteMember", {
              data: {
                memberId: context.inviteModel.memberId,
                role: context.inviteModel.role,
                beOwner: false,
                goalId: goalId,
              },
            })
            .then((response) => {
              context.$store.dispatch("goal/get", {
                id: goalId,
              });
              context.currentPage = "members";
            })
            .finally(() => {
              context.sending = false;
              target.disabled = false;
            });
        } else {
          target.disabled = false;
          context.sending = false;
        }
      });
    },
    showInviteUser() {
      this.inviteModel.memberId = null;
      this.inviteModel.role = null;

      this.currentPage = "invite";
    },
    assignCurrentMember(member) {
      this.changingRoleByUser = false;
      this.currentMember = Object.assign({}, member);
      this.currentMemberOriginalRole = member.role;
      this.changingRoleByUser = true;
    },
    handleChangeRole(role) {
      let context = this;
      if (context.changingRoleByUser) {
        if (context.currentMemberOriginalRole == 3 || context.currentMemberOriginalRole == 6) {
          Modal.confirm({
            title: "Change Users Target Role?",
            content: "<p>This user may have historical check-in data in this target. If you proceed with this role change, the check-in data will be lost.</p><p>Do you want to proceed?</p>",
            okText: "Proceed with role change",
            cancelText: "Never mind",
            onOk: () => {
              context.updateMemberRole(role);
            },
            onCancel: () => {
              context.changingRoleByUser = false;
              context.currentMember.role = context.currentMemberOriginalRole;
              context.changingRoleByUser = true;
            },
          });
        } else {
          context.updateMemberRole(role);
        }
      }
    },
    updateMemberRole(role) {
      let context = this;
      let goalId = this.$store.state.goal.currentGoal.id;

      let data = {
        email: context.currentMember.memberEmailAddress,
        role: role,
        goalId: goalId,
        memberId: context.currentMember.memberId,
      };

      this.$store
        .dispatch("goal/updateMember", {
          data: data,
        })
        .then((response) => {
          context.$store.dispatch("goal/get", {
            id: goalId,
          });
          context.currentMemberOriginalRole = role;
          context.currentMember.role = role;
        })
        .catch((error) => {
          context.changingRoleByUser = false;
          context.currentMember.role = context.currentMemberOriginalRole;
          context.changingRoleByUser = true;
        });
    },
    handleRemove() {
      let context = this;
      let goalId = context.$store.state.goal.currentGoal.id;
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;

      let data = {
        email: context.currentMember.memberEmailAddress,
        goalId: goalId,
      };
      if (context.currentMember.memberId) {
        (data as any).memberId = context.currentMember.memberId;
      }

      let popupContent =
        context.currentMemberOriginalRole == 3 || context.currentMemberOriginalRole == 6
          ? "<p>This user may have historical check-in data in this target. If you proceed with removing this user the check-in data will be lost. Do you want to proceed?</p>"
          : "<p>You are about to move this user's access to this target. Do you want to proceed?</p>";
      Modal.confirm({
        title: "Remove User From Target?",
        content: popupContent,
        okText: "Proceed with user removal",
        cancelText: "Never mind",
        onOk: () => {
          context.removeMember(data, () => {
            target.disabled = false;
          });
        },
        onCancel: () => {
          target.disabled = false;
        },
      });
    },
    removeMember(removeInput, callback) {
      let context = this;
      context.$store
        .dispatch("goal/removeMember", {
          data: removeInput,
        })
        .then((response) => {
          context.$store.dispatch("goal/get", {
            id: removeInput.goalId,
          });
          context.$emit("cancel");
        })
        .finally(() => {
          if (callback) {
            callback();
          }
        });
    },
    handleMemberClick(member) {
      this.currentPage = "member";
      this.assignCurrentMember(member);
    },
    handleBackClick() {
      if (this.currentPage == "member") {
        this.currentPage = "members";
      } else {
        this.currentPage = "member";
      }
    },
  },
});
